@if (showRepeatButton$ | async) {
  <button
    class="button"
    sdButton
    [loading]="loading$ | async"
    radius="l"
    type="primary"
    fullWidth="true"
    (click)="repeatOrder()"
  >
    Повторить заказ
  </button>
}
